/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_Q2Inputs */

const en_pc_online_faq_q2 = /** @type {(inputs: Pc_Online_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are my PDFs uploaded anywhere?`)
};

const zh_pc_online_faq_q2 = /** @type {(inputs: Pc_Online_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我的 PDF 会被上传吗？`)
};

/**
* | output |
* | --- |
* | "Are my PDFs uploaded anywhere?" |
*
* @param {Pc_Online_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_q2 = /** @type {((inputs?: Pc_Online_Faq_Q2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_Q2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_q2(inputs)
	return zh_pc_online_faq_q2(inputs)
});
export { pc_online_faq_q2 as "pc.online.faq.q2" }